import { DELETE } from "../../../APiHelper/API";

export const deleteCupRefereeAPI = (
    refereeId,
    onSuccess,
    onError
) => {
    DELETE(`/api/v1/cups/referee/${refereeId}`, onSuccess, onError, true)
}